var _style, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgRight = function SvgBgRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 892 893",
    style: {
      enableBackground: "new 0 0 892 893"
    },
    xmlSpace: "preserve",
    width: 892,
    height: 893,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.BGRight_st0{fill:#F5FBFD;}\n\t.BGRight_st1{fill:url(#SVGID_1_);}\n\t.BGRight_st2{fill:#EDF8FA;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "BGRight_st0",
    points: "501.7,0.6 696.1,195.1 890.5,0.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.024,
    y1: 6,
    x2: 446.024,
    y2: 890.0814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5FBFD",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "BGRight_st1",
    points: "1.5,889.7 890.5,889.7 890.5,389.5 696.1,195.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "BGRight_st2",
    points: "696.1,195.1 890.5,389.5 890.5,0.6 "
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BGRight.dbb4cd5b2d299ec62479d16dc375333a.svg";